import React from 'react'

import clsx from 'clsx'

import ClickoutWrapper from 'components/ClickoutWrapper'
import CtaButton from 'components/CtaButton'
import Icon from 'components/Icon'
import Link from 'components/Link'
import Logo from 'components/Logo'
import Rating from 'components/Rating'
import { useEventContext } from 'context/EventContext'
import openUrl from 'helpers/openUrl'
import { revealSEOUrl } from 'helpers/SEOHelper'

import classes from './AlternativeListing.module.scss'

const EXP_LOGO_SIZE = 40

/** @type {import("./types").default} */
const AlternativeListing = ({ listing, listingPosition }) => {
  const {
    logo: logoUrl,
    rating_avg: ratingAverage,
    num_reviews: reviewsNumber,
    is_premium: isPremium,
    compare_page: comparePageData,
    name: title,
    cta_url: ctaUrl,
    reviews_url,
    detail_url,
  } = listing
  const { addEvent } = useEventContext()

  return (
    <div className={clsx('AlternativeListing', classes.experimentContainer)}>
      <div className={classes.details}>
        <div className={classes.itemLeft}>
          <ClickoutWrapper
            url={ctaUrl}
            isClickout={isPremium}
            buyerIntentProductId={listing.global_product_id}
            buyerIntentSourceLocation="compare/desktop-alternative:logo"
            buyerIntentTrackAdClick={isPremium}
            listingPosition={listingPosition}
            {...addEvent({
              productClickPosition: listingPosition,
              engagementComponent: 'product_alternatives_card-item',
              engagementDestination: isPremium ? 'go-to_vendor-website' : 'go-to_product_details',
              engagementDetails: 'logo_product',
              name: isPremium ? 'engagement_product_clickout' : 'engagement_product_click',
            })}
          >
            <Logo src={logoUrl} size={EXP_LOGO_SIZE} alt={title} fetchWidth={EXP_LOGO_SIZE} />
          </ClickoutWrapper>
        </div>

        <div className={clsx(classes.itemRight, classes.miniCard)}>
          <ClickoutWrapper
            url={ctaUrl}
            isClickout={isPremium}
            buyerIntentProductId={listing.global_product_id}
            buyerIntentSourceLocation="compare/desktop-alternative:name"
            buyerIntentTrackAdClick={isPremium}
            listingPosition={listingPosition}
            {...addEvent({
              productClickPosition: listingPosition,
              engagementComponent: 'product_alternatives_card-item',
              engagementDestination: isPremium ? 'go-to_vendor-website' : 'go-to_product_details',
              engagementDetails: 'text-link_product-name',
              name: isPremium ? 'engagement_product_clickout' : 'engagement_product_click',
            })}
          >
            <Link className={classes.titleHeadingExp} forceComponent="h3">
              {title}
              {isPremium && <Icon icon={['far', 'external-link']} size="12" className={classes.externalLink} />}
            </Link>
          </ClickoutWrapper>
          <div className={classes.rating}>
            <Rating.Link
              className={classes.ratingExp}
              average={ratingAverage}
              totals={reviewsNumber}
              isCompact
              href={reviewsNumber > 0 && (reviewsNumber <= 7 ? `${detail_url}#reviews` : reviews_url)}
              {...addEvent({
                engagementComponent: 'product_alternatives_card-item',
                engagementDetails: `text-link_number-reviews`,
                name: 'engagement_product_click',
                engagementDestination: `go-to_product_${reviewsNumber <= 7 ? 'details' : 'reviews'}`,
              })}
            />
          </div>
        </div>
      </div>
      {comparePageData.url && (
        <CtaButton
          className={classes.compareButton}
          href={comparePageData.is_seo && revealSEOUrl(comparePageData.url)}
          onClick={() => {
            if (!comparePageData.is_seo) openUrl(revealSEOUrl(comparePageData.url))
          }}
          variant="outlined"
          {...addEvent({
            engagementComponent: 'product_alternatives_card-item',
            engagementDestination: 'go-to_product_comparisons',
            engagementDetails: 'button_compare',
            name: 'engagement_cta_compare',
          })}
        >
          <span className={classes.compareButtonContent}>
            <Icon icon={['ga', 'compare']} size={24} />
            <span>COMPARE</span>
          </span>
        </CtaButton>
      )}
    </div>
  )
}

export default AlternativeListing
